import { connect } from 'react-redux'
import './SectionItem.scss'

const SectionItem = (props) => {
    const componentClass = 'smart-new-activity-section-item'

    return (
        <div className={`${componentClass}__item`}>
            {props.children}
        </div>
    )
}

const mapStateToProps = (state: any) => ({})

const mapDispatchToProps = (dispatch: any) => ({})

export default connect(mapStateToProps, mapDispatchToProps)(SectionItem)
